/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Session_OpenInputs */

const en_us2_workout_session_open = /** @type {(inputs: Workout_Session_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That workout is still open. End it before deleting it.`)
};

const pt_br2_workout_session_open = /** @type {(inputs: Workout_Session_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse treino ainda está aberto. Encerre-o antes de apagar.`)
};

const es_419_workout_session_open = /** @type {(inputs: Workout_Session_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese entrenamiento sigue abierto. Termínalo antes de eliminarlo.`)
};

const pt_pt2_workout_session_open = /** @type {(inputs: Workout_Session_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse treino ainda está aberto. Termina-o antes de o apagares.`)
};

const fr_fr2_workout_session_open = /** @type {(inputs: Workout_Session_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette séance est encore ouverte. Termine-la avant de la supprimer.`)
};

const de_de2_workout_session_open = /** @type {(inputs: Workout_Session_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training ist noch offen. Beende es, bevor du es löschst.`)
};

const it_it2_workout_session_open = /** @type {(inputs: Workout_Session_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo allenamento è ancora aperto. Concludilo prima di eliminarlo.`)
};

/**
* | output |
* | --- |
* | "That workout is still open. End it before deleting it." |
*
* @param {Workout_Session_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_session_open = /** @type {((inputs?: Workout_Session_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Session_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_session_open(inputs)
	if (locale === "es-419") return es_419_workout_session_open(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_session_open(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_session_open(inputs)
	if (locale === "de-DE") return de_de2_workout_session_open(inputs)
	if (locale === "it-IT") return it_it2_workout_session_open(inputs)
	return en_us2_workout_session_open(inputs)
});
export { workout_session_open as "workout.session_open" }